import {combineReducers} from 'redux'

import application from '../core/reducers/application'
import data from '../core/reducers/data'
import dataQueries from '../core/reducers/dataQueries'
import edits from '../core/reducers/edits'
import errors from '../core/reducers/errors'
import exportMap from '../core/reducers/exportMap'
import layerInfos from '../core/reducers/layerInfos'
import map from '../core/reducers/map'
import popups from '../core/reducers/popups'
import sidebar from '../core/reducers/sidebar'
import app from './app'
import {constrImport} from './constrImport'
import regImport from './regimport'
import userInfo from './userInfo'

const rootReducer = combineReducers({
  application,
  app,
  data,
  layerInfos,
  map,
  errors,
  popups,
  sidebar,
  userInfo,
  exportMap,
  dataQueries,
  edits,
  regImport,
  constrImport
})

export default rootReducer
